export default "__VITE_ASSET__zCEzPDYQ__"